import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5c49af78&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=5c49af78&prod&lang=scss"
import style1 from "./details.vue?vue&type=style&index=1&id=5c49af78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c49af78",
  null
  
)

export default component.exports